import { useMemo } from 'react';
import { GlobalThemeOverrides } from '@/types/menuBuilder';
import { BACKGROUND_PATTERNS } from '@/utils/backgroundPatterns';

export function useGlobalThemeStyles(globalTheme?: GlobalThemeOverrides) {
  return useMemo(() => {
    const baseStyle: React.CSSProperties = {
      backgroundColor: globalTheme?.backgroundColor,
      color: globalTheme?.textColor,
      fontFamily: globalTheme?.fontFamily,
      fontWeight: globalTheme?.fontWeight,
    };

    if (!globalTheme) return baseStyle;

    switch (globalTheme.backgroundType) {
      case 'gradient':
        return {
          ...baseStyle,
          backgroundImage: `linear-gradient(${globalTheme.gradientDirection || 'to bottom'}, ${globalTheme.gradientStart || '#ffffff'}, ${globalTheme.gradientEnd || '#f3f4f6'})`,
        };
      case 'image':
        return {
          ...baseStyle,
          backgroundImage: globalTheme.backgroundImage ? `url(${globalTheme.backgroundImage})` : undefined,
          backgroundSize: globalTheme.backgroundSize || 'cover',
          backgroundPosition: globalTheme.backgroundPosition || 'center',
          backgroundRepeat: 'no-repeat',
        };
      case 'pattern':
        if (globalTheme.backgroundPattern && BACKGROUND_PATTERNS[globalTheme.backgroundPattern]) {
          return {
            ...baseStyle,
            ...BACKGROUND_PATTERNS[globalTheme.backgroundPattern].style,
          };
        }
        return baseStyle;
      case 'solid':
      default:
        return baseStyle;
    }
  }, [globalTheme]);
}
